import { useEffect, useState } from 'react';

import {
  Container,
  Flex,
  useBoolean,
  useBreakpointValue,
  Box,
  // useMediaQuery,
} from '@chakra-ui/react';
import { default as NextImage } from 'next/image';
import { useRouter } from 'next/router';

import { getHeaderData } from './SidebarLayout.api';
import style from './SidebarLayout.style';
import { HeaderDataType, IDashboardLayout } from './SidebarLayout.type';
import Header from '../../organism/dashboard/Header';
import Sidebar from '../../organism/dashboard/Sidebar';

import dashboardImage from '@/assets/images/HomePageBackground.jpg';
import dashboardMobileImage from '@/assets/images/mobileDMTBackground.png';
import { Icon, JourneyProgress, Link, Text } from '@/components';
import AppRoutes from '@/constants/AppRoutes';
import { ImageDefaultSizes } from '@/helpers/utils';
import useTranslation from '@/hooks/useTranslate';
import { getFeatureFlagsList } from '@/services/api';

const SidebarLayout = ({
  children,
  hasBackToServices = false,
  isHomePage = false,
  backToServicesButton, // deListedVendor = false,
}: IDashboardLayout) => {
  const { t } = useTranslation();

  const [isMenuOpen, setIsMenuOpen] = useBoolean();
  const [data, setData] = useState<HeaderDataType>();
  const router = useRouter();
  const isBelowScreenWidthXl = useBreakpointValue(
    {
      base: true,
      lg: false,
    },
    { fallback: 'lg' }
  );

  const { locale = '', route } = router;

  const isHomePageRoute = router.pathname === AppRoutes.Dashboard.Home;

  const logoPath = AppRoutes.Dashboard.Home;

  const isDashboardPage = router.pathname.startsWith('/dashboard');
  const [featureFlags, setFeatureFlags] = useState<any>({});
  // console.log(isDashboardPage, isHomePageRoute, 'iiiiiii');
  useEffect(() => {
    const fetchFlags = async () => {
      try {
        const flags = await getFeatureFlagsList();
        setFeatureFlags(flags || {});
      } catch (error) {
        console.error('Error fetching feature flags:', error);
        // Set default flags to prevent UI break - show all features by default
        setFeatureFlags({});
      }
    };
    fetchFlags();
  }, []);

  const dmtEnable = featureFlags?.['teyaseer-dmtEnabled'];


  useEffect(() => {
    // disable page scroll when menu is open and screen is below xl
    if (isMenuOpen && isBelowScreenWidthXl) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [isMenuOpen]);

  useEffect(() => {
    getHeaderData(locale).then((res: any) => {
      if (res) setData(res);
    });
  }, [locale]);

  const isMobileDevice = useBreakpointValue({
    base: true,
    md: false,
  });

  return (
    <Flex
      __css={{ ...style.root, overflow: isHomePageRoute ? 'hidden' : 'none' }}
    >
      <Header
        data={data}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        page={route}
        {...(isDashboardPage && { logoPath })}
      />

      <Flex
        __css={{
          ...style.contentWrapper,
          overflow: isHomePageRoute ? 'hidden' : 'none',
        }}
      >
        <Sidebar
          data={data}
          isMenuOpen={isMenuOpen}
          setIsMenuOpen={setIsMenuOpen}
        />
        <Flex
          __css={{
            ...style.mainBox,
            overflowY: isHomePageRoute ? 'auto' : 'none',
          }}
          as={'main'}
        >
          {dmtEnable == true ? (<>
            {isHomePage && (
              <Box
                position="fixed"
                inset="0"
                zIndex={-1}
                overflow="hidden"
                display={isHomePage ? 'block' : 'none'}
              >
                <Box position="absolute" top="60px" left="0" right="0" bottom="0">
                  <NextImage
                    src={isMobileDevice ? dashboardMobileImage : dashboardImage}
                    alt="Dashboard background"
                    fill
                    style={{
                      objectFit: 'cover',
                      objectPosition: 'top',
                    }}
                    sizes={ImageDefaultSizes}
                  />
                </Box>

                {/* Optional overlay for readability */}
                <Box position="absolute" inset="0" zIndex={0} />
              </Box>
            )}
          </>
          ) : null}

          {!isHomePageRoute && (
            <Container sx={{ maxWidth: '100%' }}>
              <JourneyProgress isHomePage={false} />
            </Container>
          )}

          {hasBackToServices && (
            <Link
              href="/dashboard/services"
              variant={'unstyled'}
              sx={style.backToService}
            >
              <Icon
                name={locale === 'ar' ? 'backARIcon' : 'arrowBack'}
                height={locale == 'ar' ? '18px' : '24px'}
              />
              <Text>{t('portal_back_to_services')}</Text>
            </Link>
          )}
          {backToServicesButton && backToServicesButton}
          <Container sx={style.container}>
            <Flex flex={1} height="100%">
              {children}
            </Flex>
          </Container>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default SidebarLayout;
